// import React from "react";

// const CustomTooltip = ({ active, payload, label }) => {
//   if (active && payload && payload.length) {
//     return (
//       <div style={{
//         backgroundColor: "#fff", 
//         zIndex: "100000",
//         padding: "0 10px", 
//         border: "1px solid #ccc", 
//         borderRadius: "5px",
//         transform: "translate(-50%, -300%)",
//       }}>
//         <p style={{ fontWeight: "bold" }}>{label}</p>
//         <p>{`${payload[0].name}: ${payload[0].value.toFixed(2)}`}</p>
//       </div>
//     );
//   }

//   return null;
// };

// export default CustomTooltip;


import React, { useEffect, useState } from "react";

const CustomTooltip = ({ active, payload, label }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    if (typeof window !== "undefined") {
      handleResize(); // Set initial value
      window.addEventListener("resize", handleResize);
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handleResize);
      }
    };
  }, []);

  if (active && payload && payload.length) {
    return (
      <div
       className="piechart-tooltip"
       style={{
        background: "white",
        opacity:'1',
        zIndex: "100000",
        padding: "0 10px",
        border: "1px solid #ccc",
        borderRadius: "5px",
        fontSize:"0.9rem",
        fontWeight: "500",
        transform: isMobile ? "translate(10%, 200%)" : "translate(-50%, -300%)",
      }}>
        <p style={{ fontWeight: "bold", fontSize:"0.9rem" }}>{label}</p>
        <p>{`${payload[0].name}: ${payload[0].value.toFixed(2)}%`}</p>
      </div>
    );
  }

  return null;
};

export default CustomTooltip;
